module.exports = "https://coursera_assets.s3.amazonaws.com/images/c5ef85b15560997dcacfdc1c1c2c95c9.svg";